module.exports = __webpack_public_path__ + "img/cancel.f85cf5aa.svg";